@if (waitlistpurchase?.error) {
  <ng-container *transloco="let twe; read 'waitlisterror'">
    <p class="reelax-red" [innerHTML]="twe('errorOccured')"></p>
    <p [innerHTML]="twe(waitlistpurchase.error)"></p>
    <p [innerHTML]="twe('commonAdvice')"></p>
  </ng-container>
}
